require('./ChannelRecommended.scss');

const b = require('app/www/libs/b')('channel-recommended');

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const Image = require('app/www/components/blocks/Image/Image');
const Link = require('app/www/components/blocks/Link/Link');
const Scroll = require('app/www/components/blocks/Scroll/Scroll');

const ChannelRecommended = (props) => {
    const {events} = props;

    const scrollProps = {
        touch: true,
    };

    return (
        <Scroll {...scrollProps}>
            {events.map(event => {
                const linkProps = {
                    url: event.url,
                    onClick: () => {
                        Metrika.trackParams('TV_EVENT', {
                            mods: {
                                watchon: true,
                            },
                            programId: event.programId,
                        });
                    },
                };

                const imageProps = {
                    mods: {
                        size: 'l',
                    },
                    sizes: event.image.sizes,
                };

                return (
                    <Link key={event.date} className={b('event')} {...linkProps}>
                        <Image key="image" className={b('image')} {...imageProps} />
                        <h4 key="title" className={b('title')}>{event.title}</h4>
                        <date key="date" className={b('date')}>{event.date}</date>
                    </Link>
                );
            })}
        </Scroll>
    );
};

ChannelRecommended.propTypes = {
    events: PropTypes.arrayOf(PropTypes.object),
};

module.exports = ChannelRecommended;
